import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import EditApiInputsForm from './form'

const EditApiInputsDialog = React.forwardRef(function EditApiInputsDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Edit API Inputs'
      subtitle={dialogState.dataSource?.displayName}
      open={dialogState.open}
      onClose={close}
      size='xmedium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <EditApiInputsForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

EditApiInputsDialog.propTypes = {
  onComplete: PropTypes.func
}

EditApiInputsDialog.defaultProps = {
  onComplete: () => {}
}

export default EditApiInputsDialog
